import {
  Autocomplete,
  Button,
  Divider,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AppButton from "../../../base/AppButton.component";
import { Box } from "@mui/system";
import { DialogStyle } from "./dialog/dialogBody/Dialog.styles";
import { useTheme } from "@emotion/react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import {
  CREATE_USER,
  MANAGE_ASSOCIATION,
  MANAGE_USER,
  UPDATE_USER,
} from "../../../../graphql/mutation/mutation";
import { useMutation, useQuery, useSubscription } from "@apollo/client";
import { useAuth } from "../../../../context/Auth.context";
import {
  GET_CALL_COUNT,
  SEARCH_MANAGER,
} from "../../../../graphql/query/query";
import {
  TYPE,
  firstOfMonth,
  today,
  userTemplateURL,
} from "../../../../utils/Utils";
import { useParams } from "react-router";
import { useAppContext } from "../../../../context/App.context";
import { InputValidation } from "../../../../utils/InputValidationRegex";
import { CheckCircle } from "@mui/icons-material";
import PromoteToManagerDialog from "./dialog/dialogBody/PromoteToManager.dialog";
import HocPopup from "../../../../hoc/hocPopup";
import { DealershipStyle } from "./Dealership.styles";
import DeactivateDialog from "./dialog/dialogBody/Deactivate.dialog";
import DeactivateUserDialog from "./dialog/dialogBody/DeactivateUser.dialog";
import { ON_EMPLOYEE_UPDATE } from "../../../../graphql/subscription/subscription";
import moment from "moment";
import AddNewUserDialog from "./dialog/dialogBody/AddNewUser.dialog";

const AddNewUserComponent = (props) => {
  console.log("props", props);
  const theme = useTheme();
  const auth = useAuth();
  const params = useParams();
  const app = useAppContext();
  const [isSaved, setSaved] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [managerAssociatedMessage, setManagerAssociatedMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    designation: "manager",
    verifyNotification: 3,
    receiveNotification: 3,
    appointmentNotification: 3,
    reviewNotification: 3,
    referralNotification: 3,
    knowledgeHubNotification: 3,
    csiNotification: 3,
    prequalNotification: 3,
    idVerificationNotification: 3,
    appDownloadNotification: 3,
    assignTarget: 10,
    fileName: "",
    file: null,
    verification_workflow_id: 1,
  });
  const INITIAL_FILTER = {
    email: "",
    dealership_id: params.dealershipId || auth?.user?.dealership_id,
  };

  const [filterData, setFilterData] = useState(INITIAL_FILTER);

  const [createUser, { loading: createLoading, data: createdUser }] =
    useMutation(CREATE_USER);
  const [updateUser, { loading: updateLoading, data: updatedUser }] =
    useMutation(UPDATE_USER);

  const { update, dialog, isAdminModule } = props;

  const { loading, data: SearchData } = useQuery(SEARCH_MANAGER, {
    skip: !isAdminModule || update,
    variables: {
      searchInput: {
        dealership_id: filterData.dealership_id,
        email: filterData.email,
      },
    },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });

  const [manageAssociation, { loading: associateLoading }] = useMutation(
    MANAGE_ASSOCIATION,
    {
      onCompleted: (data) => {
        data?.manageAssociation?.employee_user_id == null
          ? setManagerAssociatedMessage("Manager Already Associated")
          : setManagerAssociatedMessage("Manager associated successfully");
        setTimeout(() => {
          setManagerAssociatedMessage("");
        }, 5000);
      },
    },
  );

  const [manageUser, { loading: promoteLoading, data: promoteUser }] =
    useMutation(MANAGE_USER);

  const manageUserHandler = () => {
    manageUser({
      variables: {
        createUserInput: {
          user_id: user.userId,
          first_name: user.firstName,
          last_name: user.lastName,
          email: user.email,
          mobile_number: user.mobileNumber.replace(/\D/g, ""),
          notification_preference: user.receiveNotification,
          verification_preference: user.verifyNotification,
          appointment_preference: user.appointmentNotification,
          review_preference: user.reviewNotification,
          referral_preference: user.referralNotification,
          knowledge_hub_preference: user.knowledgeHubNotification,
          csi_preference: user.csiNotification,
          prequal_preference: user.prequalNotification,
          id_verification_preference: user.idVerificationNotification,
          app_download_preference: user.appDownloadNotification,
          role: user.designation,
          // current_target: user.assignTarget,
          created_by: auth.user.user_id,
          updated_by: auth.user.user_id,
          dealership_id: params.dealershipId || auth?.user?.dealership_id,
          employee_user_id: user.userId,
          d_startDate: firstOfMonth,
          d_endDate: today,
          f_startDate: firstOfMonth,
          f_endDate: today,
          timezone: new Date().getTimezoneOffset(),
          is_active: true,
          is_promote: true,
          verification_workflow_id: user?.verification_workflow_id,
          isAdmin: true,
        },
      },
    }).then(() => {
      setSaved(true);
      showSuccess();
    });
  };

  const handleAssociation = (email) => {
    manageAssociation({
      variables: {
        associateInput: {
          dealership_id: params.dealershipId || auth?.user?.dealership_id,
          email: email,
          associate: true,
          d_startDate: firstOfMonth,
          d_endDate: today,
          timezone: new Date().getTimezoneOffset(),
          isAdmin: true,
          created_by: parseInt(auth?.user?.user_id),
          updated_by: parseInt(auth?.user?.user_id),
        },
      },
    }).then((data) => {
      console.log("sddd", data);
    });
  };
  useEffect(() => {
    if (update) {
      setUser({
        firstName: update.first_name,
        lastName: update.last_name,
        email: update.email,
        mobileNumber: update.mobile_number,
        designation: update.role,
        receiveNotification: update.notification_preference,
        verifyNotification: update.verification_preference,
        appointmentNotification: update.appointment_preference,
        reviewNotification: update.review_preference,
        referralNotification: update.referral_preference,
        knowledgeHubNotification: update.knowledge_hub_preference,
        csiNotification: update.csi_preference,
        prequalNotification: update.prequal_preference,
        idVerificationNotification: update.id_verification_preference,
        appDownloadNotification: update.app_download_preference,
        assignTarget: update.assigned_target,
        userId: update.employee_user_id,
        verification_workflow_id: update?.verification_workflow_id,
      });
    }
  }, [update]);

  useEffect(() => {
    if (createdUser || promoteUser) {
      setSaved(true);
      setUser({
        firstName: "",
        lastName: "",
        email: "",
        mobileNumber: "",
        designation: "manager",
        verifyNotification: 3,
        receiveNotification: 3,
        appointmentNotification: 3,
        reviewNotification: 3,
        referralNotification: 3,

        knowledgeHubNotification: 3,
        csiNotification: 3,
        prequalNotification: 3,
        idVerificationNotification: 3,
        appDownloadNotification: 3,
        assignTarget: 10,
        fileName: "",
        file: null,
        verification_workflow_id: 1,
      });
    }
    if (updatedUser || promoteUser) {
      setSaved(true);
      console.log("update", updatedUser);
      setUser({
        firstName: "",
        lastName: "",
        email: "",
        mobileNumber: "",
        designation: "manager",
        verifyNotification: 3,
        receiveNotification: 3,
        appointmentNotification: 3,
        reviewNotification: 3,
        referralNotification: 3,
        knowledgeHubNotification: 3,
        csiNotification: 3,
        prequalNotification: 3,
        idVerificationNotification: 3,
        appDownloadNotification: 3,
        assignTarget: 10,
        fileName: "",
        file: null,
        verification_workflow_id: 1,
      });
    }
  }, [createdUser, updatedUser, promoteUser]);

  const showSuccess = () => {
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 5000);
  };

  const createUserHandler = () => {
    createUser({
      variables: {
        createUserInput: {
          first_name: user.firstName,
          last_name: user.lastName,
          middle_name: "",
          email: user.email,
          mobile_number: user.mobileNumber.replace(/\D/g, ""),
          role: user.designation,
          notification_preference: user.receiveNotification,
          verification_preference: user.verifyNotification,
          appointment_preference: user.appointmentNotification,
          review_preference: user?.reviewNotification,
          referral_preference: user?.referralNotification,
          knowledge_hub_preference: user.knowledgeHubNotification,
          csi_preference: user.csiNotification,
          prequal_preference: user.prequalNotification,
          id_verification_preference: user.idVerificationNotification,
          app_download_preference: user.appDownloadNotification,
          // current_target: user.assignTarget,
          created_by: auth.user.user_id,
          updated_by: auth.user.user_id,
          dealership_id: params.dealershipId || auth?.user?.dealership_id,
          employee_user_id: null,
          d_startDate: firstOfMonth,
          d_endDate: today,
          f_startDate: firstOfMonth,
          f_endDate: today,
          timezone: new Date().getTimezoneOffset(),
          is_active: true,
          verification_workflow_id: user?.verification_workflow_id,
          isAdmin: params?.dealershipId ? true : false,
        },
      },
    }).then(() => {
      showSuccess();
    });
  };
  const updateUserHandler = () => {
    if (!isAdminModule) {
      if (user?.userId === auth?.user?.user_id) {
        let index = auth?.user?.associateDetails?.findIndex((workflow) => {
          return workflow?.dealership_id === auth.user.dealership_id;
        });
        if (index !== -1) {
          const updatedWorkflow = [...auth?.user?.associateDetails];
          updatedWorkflow[index] = {
            ...updatedWorkflow[index],
            verification_workflow_id: user?.verification_workflow_id,
          };
          const updatedData = {
            ...auth?.user,
            first_name: user.firstName,
            last_name: user.lastName,
            associateDetails: updatedWorkflow,
          };
          auth.login(updatedData);
        }
      }
    }
    updateUser({
      variables: {
        createUserInput: {
          user_id: user.userId,
          first_name: user.firstName,
          last_name: user.lastName,
          email: user.email,
          mobile_number: user.mobileNumber.replace(/\D/g, ""),
          notification_preference: user.receiveNotification,
          verification_preference: user.verifyNotification,
          appointment_preference: user.appointmentNotification,
          review_preference: user?.reviewNotification,
          referral_preference: user?.referralNotification,
          knowledge_hub_preference: user.knowledgeHubNotification,
          csi_preference: user.csiNotification,
          prequal_preference: user.prequalNotification,
          id_verification_preference: user.idVerificationNotification,
          app_download_preference: user.appDownloadNotification,
          role: user.designation,
          // current_target: user.assignTarget,
          created_by: auth.user.user_id,
          updated_by: auth.user.user_id,
          dealership_id: params.dealershipId || auth?.user?.dealership_id,
          employee_user_id: null,
          d_startDate: firstOfMonth,
          d_endDate: today,
          f_startDate: firstOfMonth,
          f_endDate: today,
          timezone: new Date().getTimezoneOffset(),
          is_active: true,
          verification_workflow_id: user?.verification_workflow_id,
          isAdmin: params?.dealershipId ? true : false,
        },
      },
    }).then(() => {
      showSuccess();
    });
  };
  const handleChange = (event, newValue) => {
    setFilterData({ ...filterData, email: newValue });
  };
  const deactivateHandler = () => {
    manageUser({
      variables: {
        createUserInput: {
          user_id: user.userId,
          first_name: user.firstName,
          last_name: user.lastName,
          email: user.email,
          mobile_number: user.mobileNumber.replace(/\D/g, ""),
          notification_preference: user.receiveNotification,
          verification_preference: user.verifyNotification,
          appointment_preference: user.appointmentNotification,
          review_preference: user?.reviewNotification,
          referral_preference: user?.referralNotification,
          knowledge_hub_preference: user.knowledgeHubNotification,
          csi_preference: user.csiNotification,
          prequal_preference: user.prequalNotification,
          id_verification_preference: user.idVerificationNotification,
          app_download_preference: user.appDownloadNotification,
          role: user.designation,
          // current_target: user.assignTarget,
          created_by: auth.user.user_id,
          updated_by: auth.user.user_id,
          dealership_id: params.dealershipId,
          employee_user_id: user.userId,
          d_startDate: firstOfMonth,
          d_endDate: today,
          f_startDate: firstOfMonth,
          f_endDate: today,
          timezone: new Date().getTimezoneOffset(),
          is_active: false,
          verification_workflow_id: user?.verification_workflow_id,
        },
      },
    }).then(() => {
      showSuccess();
    });
  };
  const activateHandler = () => {
    manageUser({
      variables: {
        createUserInput: {
          user_id: user.userId,
          first_name: user.firstName,
          last_name: user.lastName,
          email: user.email,
          mobile_number: user.mobileNumber.replace(/\D/g, ""),
          notification_preference: user.receiveNotification,
          verification_preference: user.verifyNotification,
          appointment_preference: user.appointmentNotification,
          review_preference: user?.reviewNotification,
          referral_preference: user?.referralNotification,
          knowledge_hub_preference: user.knowledgeHubNotification,
          csi_preference: user.csiNotification,
          prequal_preference: user.prequalNotification,
          id_verification_preference: user.idVerificationNotification,
          app_download_preference: user.appDownloadNotification,
          role: user.designation,
          // current_target: user.assignTarget,
          created_by: auth.user.user_id,
          updated_by: auth.user.user_id,
          dealership_id: params.dealershipId || auth?.user?.dealership_id,
          employee_user_id: user.userId,
          d_startDate: firstOfMonth,
          d_endDate: today,
          f_startDate: firstOfMonth,
          f_endDate: today,
          timezone: new Date().getTimezoneOffset(),
          is_active: true,
          verification_workflow_id: user?.verification_workflow_id,
        },
      },
    }).then((data) => {
      console.log("success", data);

      showSuccess();
    });
  };

  useEffect(() => {
    const msg =
      createdUser?.createUser?.errors || updatedUser?.updateUser?.errors;

    if (msg) {
      setErrorMessage(
        createdUser?.createUser?.errors
          ? createdUser?.createUser?.errors[0].message
          : updatedUser?.updateUser?.errors[0].message,
      );
      setTimeout(() => {
        setErrorMessage("");
      }, 5000);
    }
  }, [createdUser, updatedUser]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "auto",
        padding: "12px",
        maxHeight: "535px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "16px",
            mb: 2,
          }}
        >
          <FormControl variant="outlined" sx={{ width: "100%" }}>
            <InputLabel
              color={
                InputValidation.nameValidation(user.firstName)
                  ? "error"
                  : "primary"
              }
            >
              First Name
            </InputLabel>
            <OutlinedInput
              required
              label="First Name"
              value={user.firstName}
              error={InputValidation.nameValidation(user.firstName)}
              onChange={(event) =>
                setUser({
                  ...user,
                  firstName: event.target.value,
                })
              }
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.nameValidation(user.firstName)
                ? "Please enter a valid name"
                : " "}
            </FormHelperText>
          </FormControl>

          <FormControl variant="outlined" sx={{ width: "100%" }}>
            <InputLabel
              color={
                InputValidation.nameValidation(user.lastName)
                  ? "error"
                  : "primary"
              }
            >
              Last Name
            </InputLabel>
            <OutlinedInput
              required
              label="Last Name"
              value={user.lastName}
              error={InputValidation.nameValidation(user.lastName)}
              onChange={(event) =>
                setUser({
                  ...user,
                  lastName: event.target.value,
                })
              }
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.nameValidation(user.lastName)
                ? "Please enter a valid name"
                : " "}
            </FormHelperText>
          </FormControl>

          <FormControl variant="outlined" sx={{ width: "100%" }}>
            <InputLabel
              color={
                InputValidation.emailValidation(user.email)
                  ? "error"
                  : "primary"
              }
            >
              Email
            </InputLabel>
            <OutlinedInput
              required
              label="Email"
              type="email"
              value={user.email}
              onChange={(event) =>
                setUser({
                  ...user,
                  email: event.target.value,
                })
              }
              error={InputValidation.emailValidation(user.email)}
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.emailValidation(user.email)
                ? "Please enter a valid email"
                : " "}
            </FormHelperText>
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "16px",
          }}
        >
          <FormControl variant="outlined" sx={{ width: "100%" }}>
            <InputLabel
              color={
                InputValidation.numberValidation(user.mobileNumber)
                  ? "error"
                  : "primary"
              }
            >
              Contact Number
            </InputLabel>
            <OutlinedInput
              label="Contact Number"
              value={InputValidation.phoneNumberFormat(user.mobileNumber)}
              type="tel"
              onChange={(event) =>
                setUser({
                  ...user,
                  mobileNumber: event.target.value,
                })
              }
              error={InputValidation.numberValidation(user.mobileNumber)}
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.numberValidation(user.mobileNumber)
                ? "Please enter a valid contact number"
                : " "}
            </FormHelperText>
          </FormControl>

          {
            <FormControl variant="outlined" sx={{ width: "100%" }}>
              <InputLabel id="designation-label">Designation</InputLabel>
              <Select
                labelId="designation-label"
                value={user.designation}
                label="Designation"
                onChange={(e) => {
                  setUser({
                    ...user,
                    designation: e.target.value,
                  });
                }}
                disabled={update}
              >
                <MenuItem value={"manager"}>Manager</MenuItem>
                <MenuItem value={"employee"}>Employee</MenuItem>
              </Select>
            </FormControl>
          }

          <FormControl variant="outlined" sx={{ width: "100%" }}>
            <InputLabel id="workflow-label">Workflow</InputLabel>
            <Select
              value={user?.verification_workflow_id}
              label="Workflow"
              labelId="workflow-label"
              onChange={(e) => {
                setUser({
                  ...user,
                  verification_workflow_id: e.target.value,
                });
              }}
            >
              <MenuItem value={1}>Verify & Offer Quote</MenuItem>
              <MenuItem value={2}>Verify Only</MenuItem>
              <MenuItem value={3}>Offer Quote Only</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr 1fr",
              gap: "16px",
            }}
          >
            {
              <>
                <FormControl variant="outlined" sx={{ width: "100%" }}>
                  <InputLabel id="verify-notification-label">
                    Verify Notification
                  </InputLabel>
                  <Select
                    labelId="verify-notification-label"
                    value={user.verifyNotification}
                    label="Verify Notification"
                    onChange={(e) => {
                      setUser({
                        ...user,
                        verifyNotification: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={3}>None</MenuItem>
                    <MenuItem value={1}>Email</MenuItem>
                    <MenuItem value={2}>Text</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant="outlined" sx={{ width: "100%" }}>
                  <InputLabel id="quote-notification-label">
                    Quote Notification
                  </InputLabel>
                  <Select
                    labelId="quote-notification-label"
                    value={user.receiveNotification}
                    label="Quote Notification"
                    onChange={(e) => {
                      setUser({
                        ...user,
                        receiveNotification: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={3}>None</MenuItem>
                    <MenuItem value={1}>Email</MenuItem>
                    <MenuItem value={2}>Text</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant="outlined" sx={{ width: "100%" }}>
                  <InputLabel id="review-notification-label">
                    Review Notification
                  </InputLabel>
                  <Select
                    labelId="review-notification-label"
                    value={user.reviewNotification}
                    label="Review Notification"
                    onChange={(e) => {
                      setUser({
                        ...user,
                        reviewNotification: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={3}>None</MenuItem>
                    <MenuItem value={1}>Email</MenuItem>
                    <MenuItem value={2}>Text</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant="outlined" sx={{ width: "100%" }}>
                  <InputLabel id="appointment-notification-label">
                    Appointment Notification
                  </InputLabel>
                  <Select
                    labelId="appointment-notification-label"
                    value={user.appointmentNotification}
                    label="Appointment Notification"
                    onChange={(e) => {
                      setUser({
                        ...user,
                        appointmentNotification: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={3}>None</MenuItem>
                    <MenuItem value={1}>Email</MenuItem>
                    <MenuItem value={2}>Text</MenuItem>
                  </Select>
                </FormControl>
              </>
            }
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr 1fr",
              gap: "16px",
            }}
          >
            {
              <>
                <FormControl variant="outlined" sx={{ width: "100%" }}>
                  <InputLabel id="referral-notification-label">
                    Referral Notification
                  </InputLabel>
                  <Select
                    labelId="referral-notification-label"
                    value={user.referralNotification}
                    label="Referral Notification"
                    onChange={(e) => {
                      setUser({
                        ...user,
                        referralNotification: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={3}>None</MenuItem>
                    <MenuItem value={1}>Email</MenuItem>
                    <MenuItem value={2}>Text</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant="outlined" sx={{ width: "100%" }}>
                  <InputLabel id="knowledge-hub-notification-label">
                    Knowledge Hub Notification
                  </InputLabel>
                  <Select
                    labelId="knowledge-hub-notification-label"
                    value={user.knowledgeHubNotification}
                    label="Knowledge Hub Notification"
                    onChange={(e) => {
                      setUser({
                        ...user,
                        knowledgeHubNotification: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={3}>None</MenuItem>
                    <MenuItem value={1}>Email</MenuItem>
                    <MenuItem value={2}>Text</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant="outlined" sx={{ width: "100%" }}>
                  <InputLabel id="csi-notification-label">
                    CSI Notification
                  </InputLabel>
                  <Select
                    labelId="csi-notification-label"
                    value={user.csiNotification}
                    label="CSI Notification"
                    onChange={(e) => {
                      setUser({
                        ...user,
                        csiNotification: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={3}>None</MenuItem>
                    <MenuItem value={1}>Email</MenuItem>
                    <MenuItem value={2}>Text</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant="outlined" sx={{ width: "100%" }} disabled>
                  <InputLabel id="prequal-notification-label">
                    PreQual Notification
                  </InputLabel>
                  <Select
                    labelId="prequal-notification-label"
                    value={user.prequalNotification}
                    label="PreQual Notification"
                    onChange={(e) => {
                      setUser({
                        ...user,
                        prequalNotification: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={3}>None</MenuItem>
                    <MenuItem value={1}>Email</MenuItem>
                    <MenuItem value={2}>Text</MenuItem>
                  </Select>
                </FormControl>
              </>
            }
          </Box>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr 1fr",
              gap: "16px",
            }}
          >
            {
              <>
                <FormControl variant="outlined" sx={{ width: "100%" }} disabled>
                  <InputLabel id="id-verification-notification-label">
                    ID Verification Notification
                  </InputLabel>
                  <Select
                    labelId="id-verification-notification-label"
                    value={user.idVerificationNotification}
                    label="ID Verification Notification"
                    onChange={(e) => {
                      setUser({
                        ...user,
                        idVerificationNotification: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={3}>None</MenuItem>
                    <MenuItem value={1}>Email</MenuItem>
                    <MenuItem value={2}>Text</MenuItem>
                  </Select>
                </FormControl>

                <FormControl variant="outlined" sx={{ width: "100%" }}>
                  <InputLabel id="app-download-notification-label">
                    App Download Notification
                  </InputLabel>
                  <Select
                    labelId="app-download-notification-label"
                    value={user.appDownloadNotification}
                    label="App Download Notification"
                    onChange={(e) => {
                      setUser({
                        ...user,
                        appDownloadNotification: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={3}>None</MenuItem>
                    <MenuItem value={1}>Email</MenuItem>
                    <MenuItem value={2}>Text</MenuItem>
                  </Select>
                </FormControl>
              </>
            }
          </Box>
        </Box>

        <Box
          sx={{ display: "flex", flexDirection: "column", gap: "12px", mt: 4 }}
        >
          <Divider />
          {update && isAdminModule && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gridTemplateColumns:
                  user.designation === "manager" ? "1fr" : "1fr 1fr",
                gap: "16px",
              }}
            >
              {user.designation !== "manager" && (
                <AppButton
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  fullWidth
                  buttonText="Promote to manager"
                  size="large"
                  variant="outlined"
                  disabled={!update?.is_active}
                  clickHandler={() => {
                    dialog({
                      open: true,
                      bodyType: TYPE.PROMOTE_EMPLOYEE,
                      body: (
                        <PromoteToManagerDialog
                          manageUserHandler={manageUserHandler}
                        />
                      ),
                      maxWidth: "large",
                    });
                  }}
                />
              )}

              {user?.firstName !== "" &&
              !InputValidation.nameValidation(user.firstName) ? (
                <AppButton
                  sx={{
                    width: user.designation === "manager" ? "50%" : "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  fullWidth
                  buttonText={
                    !update?.is_active ? "Activate User" : "Deactivate User"
                  }
                  size="large"
                  variant="outlined"
                  disabled={
                    user.fileName
                      ? false
                      : createLoading ||
                        updateLoading ||
                        user.firstName === "" ||
                        user.lastName === "" ||
                        user.email === "" ||
                        user.mobileNumber === "" ||
                        InputValidation.nameValidation(user.firstName) ||
                        InputValidation.nameValidation(user.lastName) ||
                        InputValidation.numberValidation(user.mobileNumber) ||
                        InputValidation.emailValidation(user.email) ||
                        !update
                  }
                  clickHandler={() => {
                    dialog({
                      open: true,
                      bodyType: TYPE.DEACTIVATE_USER,
                      body: (
                        <DeactivateUserDialog
                          activateHandler={activateHandler}
                          deactivateHandler={deactivateHandler}
                          is_active={update?.is_active}
                        />
                      ),
                      maxWidth: "large",
                    });
                  }}
                />
              ) : null}
            </Box>
          )}
          {createdUser?.createUser?.dealership_id ||
          updatedUser?.updateUser?.dealership_id ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {showSuccessMessage ? (
                <>
                  <CheckCircle color={"primary"} />
                  <span
                    style={{
                      color: theme.palette.primary.main,
                      marginLeft: "4px",
                    }}
                  >
                    SUCCESS
                  </span>
                </>
              ) : (
                <AppButton
                  sx={{
                    width: "15%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    alignSelf: "flex-end",
                  }}
                  buttonText={update ? "Update" : "Create User"}
                  clickHandler={update ? updateUserHandler : createUserHandler}
                  size="medium"
                  variant="contained"
                  disabled={
                    user.fileName
                      ? false
                      : createLoading ||
                        updateLoading ||
                        user.firstName === "" ||
                        user.lastName === "" ||
                        user.email === "" ||
                        user.mobileNumber === "" ||
                        InputValidation.nameValidation(user.firstName) ||
                        InputValidation.nameValidation(user.lastName) ||
                        InputValidation.numberValidation(user.mobileNumber) ||
                        InputValidation.emailValidation(user.email) ||
                        (update && !update?.is_active)
                  }
                  loading={createLoading || updateLoading}
                />
              )}
            </Box>
          ) : (
            <>
              <AppButton
                sx={{
                  width: "15%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  alignSelf: "flex-end",
                }}
                buttonText={update ? "Update" : "Create User"}
                clickHandler={update ? updateUserHandler : createUserHandler}
                size="medium"
                variant="contained"
                disabled={
                  user.fileName
                    ? false
                    : createLoading ||
                      updateLoading ||
                      user.firstName === "" ||
                      user.lastName === "" ||
                      user.email === "" ||
                      user.mobileNumber === "" ||
                      InputValidation.nameValidation(user.firstName) ||
                      InputValidation.nameValidation(user.lastName) ||
                      InputValidation.numberValidation(user.mobileNumber) ||
                      InputValidation.emailValidation(user.email) ||
                      (update && !update?.is_active)
                }
                loading={createLoading || updateLoading}
              />
              {errorMessage && (
                <Typography
                  variant="body2"
                  sx={{ textAlign: "center", color: "red", mt: 1 }}
                >
                  {errorMessage}
                </Typography>
              )}
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default HocPopup(AddNewUserComponent);
